import * as t from 't';
import _ from 'lodash';

function appendNodeToTree(root, nodeToAppend) {
  const parentToAppend = t.find(root,
    node => parseInt(node.id, 10) === parseInt(nodeToAppend.parentId, 10));

  if (!parentToAppend) {
    return;
  }
  parentToAppend.children.push(nodeToAppend);
}

function getTreeDataFromListData(accountHierarchy, root, onlyFamilyAccounts) {
  if (accountHierarchy.length === 0) {
    return root;
  }

  const maxDepth = _.maxBy(accountHierarchy, item => item.depth).depth;

  for (let depth = 1; depth <= maxDepth; depth += 1) {
    const nodesAtDepth = _.filter(accountHierarchy, item => item.depth === depth);

    const subAcccountNodes = _.filter(nodesAtDepth, node => node.isSubAccount === true);
    const nonSubAccountsNodes = _.filter(nodesAtDepth, node => node.isSubAccount === false);

    const nodesToAppend = onlyFamilyAccounts
      ? subAcccountNodes
      : [...nonSubAccountsNodes, ..._.filter(subAcccountNodes, node => node.depth !== 1)];

    nodesToAppend.forEach((node) => {
      appendNodeToTree(root, node);
    });
  }

  return root;
}

function sanitizeDataForOrgChart(accountHierarchy, root, onlyFamilyAccounts) {
  const treeData = getTreeDataFromListData(accountHierarchy, root, onlyFamilyAccounts);
  return [treeData];
}

export default sanitizeDataForOrgChart;
